import React from "react";
import "./ReservableCard.css";
import logo from "../../images/car.svg";
import { useTheme } from "context/themeContext";

const ReservableCard = ({ trip, handler }) => {
   const { countryProperties } = useTheme();
  return (
    <div className="reservable-card" onClick={() => handler(trip)}>
      <div className="reservable-card-header">
        <p><strong>{trip?.route}</strong></p>
       
      </div>

      <div className="reservable-info-container">
      <div className="reservable-card-body">
      <p><span className="reservable-price">
          {trip?.price
            ? new Intl.NumberFormat(countryProperties.locale, {
                style: "currency",
                currency: countryProperties.currency_code,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(trip?.price)
            : "N/A"}
        </span></p>
        <p><strong>Date:</strong> {trip?.departureDate}</p>
        <p><strong>Time:</strong> {trip?.departureTime || "—"}</p>
        <p><strong>Vehicle:</strong> {trip?.vehicle || "—"}</p>
      </div>

      <div className="reservable-card-image">
      <div
              
              style={{
                padding: "5px",
                marginRight:"15px",
               marginTop:"20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "60px",
                height: "60px",
              }}
            >
              <img
                src={logo}
                onError={(e) => {
                  e.target.src = logo;
                }}
                alt="logo"
                width="60px"
                height="auto"
                style={{ objectFit: "contain" }}
              />
            </div>
      </div>
      </div>
      

      {/* <div className="reservable-card-footer">
        <button className="reservable-btn">Reserve Now</button>
      </div> */}
    </div>
  );
};

export default ReservableCard;
